import { render } from "./SenaraiBank.vue?vue&type=template&id=0c09625d"
import script from "./SenaraiBank.vue?vue&type=script&lang=js"
export * from "./SenaraiBank.vue?vue&type=script&lang=js"

import "./SenaraiBank.vue?vue&type=style&index=0&id=0c09625d&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__